export const STICKY_NODE_MAIN_SHAPE = 'mainShape';
